import { useOpenDashApp } from "@opendash/core";

export function useUserGuideSelect<T>() {
  const app = useOpenDashApp();

  function select(selector: T | string) {
    return app?._refs?.layout?.current?.querySelector<HTMLElement>(
      "#" + selector
    );
  }

  return select;
}
